<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    xml:space="preserve"
  >
    <path
      d="M10.3,10.1V7.8c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v2.3c0.7-0.5,1.2-1.3,1.2-2.3
        c0-1.5-1.2-2.8-2.8-2.8C10.3,5,9,6.2,9,7.8C9,8.7,9.5,9.6,10.3,10.1z M16.3,12.9l-2.8-1.4c-0.1,0-0.2-0.1-0.3-0.1h-0.5V7.8
        c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v6.6c-2.2-0.5-2.2-0.5-2.3-0.5c-0.2,0-0.4,0.1-0.5,0.2l-0.5,0.5l3,3
        c0.2,0.2,0.4,0.3,0.7,0.3h4.2c0.5,0,0.8-0.3,0.9-0.8l0.5-3.2c0,0,0-0.1,0-0.1C16.9,13.4,16.6,13,16.3,12.9z"
    />
    <circle
      cx="4.6"
      cy="7.6"
      r="2.1"
      fill="none"
      stroke="currentColor"
    />
    <circle
      cx="19.4"
      cy="7.6"
      r="2.1"
      fill="none"
      stroke="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Choose'
  }
</script>
